/* eslint-disable no-console */
import Vue from 'vue';

import { register } from 'register-service-worker'

import firebase from 'firebase/app';
import 'firebase/messaging';
if (process.env.NODE_ENV === 'production') {
  
  //register(`${process.env.BASE_URL}service-worker.js`, {
  //lal?

  const config = {
      apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
      authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
      //databaseURL: "https://playboxcade-87e57.firebaseio.com",
      projectId: process.env.VUE_APP_FIREBASE_PROJECTID,
      //storageBucket: "playboxcade-87e57.appspot.com",
      messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGE_SENDER_ID,
      appId: process.env.VUE_APP_FIREBASE_APP_ID
  }
  const messageSenderId = encodeURIComponent(config.messagingSenderId);
  const projectId = encodeURIComponent(config.projectId);
  const apiKey = encodeURIComponent(config.apiKey);
  const authDomain = encodeURIComponent(config.authDomain);
  const appId = encodeURIComponent(config.appId);

  register(`${process.env.BASE_URL}pbc-service-worker.js?messageSenderId=${messageSenderId}&projectId=${projectId}&apiKey=${apiKey}&authDomain=${authDomain}&appId=${appId}`, {
    ready (registration) {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
      //messaging.useServiceWorker(registration);
    },
    registered (registration) {
      console.log('Service worker has been registered.')
      firebase.initializeApp(config);
      const messaging = firebase.messaging();

      Vue.prototype.$messaging = messaging;
      console.log('messaging', messaging);

      messaging.useServiceWorker(registration);
    },
    cached (registration) {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; please refresh.')
      //messaging.useServiceWorker(registration);
      //refresh the thing here i guess
      Vue.prototype.$eventbus.emit('serviceWorkerUpdated', registration);
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
